module.exports = __webpack_public_path__ + "static/keishia-831b8a4b3a8d944c8ce2dabcd04e7b93.svg";